import { configFactory, getOrThrow } from '@digitsole/blackburn-configuration';

export const apiConfig = configFactory({
  default: getOrThrow('api.url', { type: 'string', prefix: 'blackburn', package: 'apps/browser' }) as string
  // plan: getOrThrow('plan', { type: 'string', prefix: 'blackburn', package: 'apps/browser' }) as string
});
